export default
`{
  "gisap_ProfileId": "051MbJV67kcLZlftZl}gPG",
  "gisap_HeadLine": "SAP UF2/100: Zeitreihen Upload",
  "email": "###UserEmail###",
  "username": "###UserName###",
  "usertoken": "###UserToken###"
}`;
